// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Z-8V","inner":"Footer_inner__33Cf_","nextIcon":"Footer_nextIcon__hWzf7","innerLeft":"Footer_innerLeft__kKhd4"};